<template>
  <div id="inline-video" class="mx-auto max-w-4xl w-full pt-12 sm:pt-14">
    <div class="px-6 sm:px-8 md:px-12 text-center">
      <SectionHeader class="header px-0 pb-10 md:px-4">
        <template #header>
          <div class="mb-4">How Does Bambee&nbsp;Work?</div>
        </template>
        <template #subheader>
          <div class="max-w-none sm:max-w-xl mx-auto">
            With the help of your dedicated HR Manager, Bambee puts your HR on
            autopilot to streamline your HR, and automate your onboarding,
            policies, and even employee training.
          </div>
        </template>
      </SectionHeader>
    </div>
    <button
      v-if="!isModalActive"
      class="block mx-auto"
      title="Watch the video"
      @click="showContent"
      @touchend="showContent"
    >
      <picture>
        <source
          srcset="
            ~/assets/images/splash/video-preview.jpg,
            ~/assets/images/splash/video-preview-2x.jpg 2x
          "
          media="(min-width: 640px)"
        />
        <source
          srcset="
            ~/assets/images/splash/video-preview-xs.jpg,
            ~/assets/images/splash/video-preview-xs-2x.jpg 2x
          "
          media="(min-width: 480px)"
        />
        <source
          srcset="~/assets/images/splash/video-preview-2xs-2x.jpg 2x"
          media="(max-width: 479px)"
        />
        <img
          src="~/assets/images/splash/video-preview-2xs.jpg"
          load="lazy"
          alt=""
          class="block max-w-full"
          :style="{ 'min-width': '279px' }"
        />
      </picture>
    </button>
    <div v-if="isModalActive" class="video-player max-w-xl mx-auto px-1 mt-8">
      <youtube
        ref="youtube"
        width="720"
        height="320"
        :video-id="videoId"
        :player-vars="playerVars"
        @playing="onVideoPlay"
        @ended="stopVideo"
      ></youtube>
    </div>
    <!-- <Portal :disabled="!isModalActive">
      <transition name="fade" appear @afterLeave="isModalActive = false">
        <VideoModal v-if="isContentActive" @close="isContentActive = false" />
      </transition>
    </Portal> -->
  </div>
</template>

<script>
import { ref } from '@nuxtjs/composition-api';
import SectionHeader from './SectionHeader';
import Analytics from '@/services/Analytics';
import { VideoHeader } from '@/modules/HomePage/constants';

export default {
  name: 'HomeVideo',
  components: { SectionHeader },
  setup() {
    const { title, subtitle } = VideoHeader;
    const isContentActive = ref(false);
    const isModalActive = ref(false);
    const showContent = () => {
      isContentActive.value = true;
      isModalActive.value = true;
    };

    const videoId = 'rzJhkTm7baY';
    const playerVars = {
      autoplay: 1,
      controls: 0,
      rel: 0,
    };

    const onVideoPlay = () => {
      // eslint-disable-next-line
      Analytics.track('Play Video', {
        category: 'get.bambee.com',
        label: 'Bambee Intro Video',
      });
    };

    const stopVideo = () => {
      isModalActive.value = false;
    };

    return {
      isContentActive,
      isModalActive,
      title,
      subtitle,
      showContent,
      videoId,
      playerVars,
      onVideoPlay,
      stopVideo,
    };
  },
};
</script>

<style scoped>
.video-player >>> iframe {
  width: 100%;
}
</style>
